import { render, staticRenderFns } from "./LibreriaCodiciTributo.vue?vue&type=template&id=37aa303c&scoped=true"
import script from "./LibreriaCodiciTributo.vue?vue&type=script&lang=js"
export * from "./LibreriaCodiciTributo.vue?vue&type=script&lang=js"
import style0 from "./LibreriaCodiciTributo.vue?vue&type=style&index=0&id=37aa303c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa303c",
  null
  
)

export default component.exports